import Vue from 'vue';
import AttributeMatcher from './AttributeMatcher.vue';

new Vue({
  el: '#asw_attribute_rule_table',
  render: h => h( AttributeMatcher )
});



// WEBPACK FOOTER //
// ./src/main.js